import { FC } from "react";
import { NavLink, useLocation } from "react-router-dom";

interface Props {
  labels: any[];
  title?: string;
  children?: React.ReactNode;
  onClick?: any;
  tab?: number;
}

const TabPanel: FC<Props> = (props) => {
  const { pathname } = useLocation();
  const { labels, children } = props;
  return (
    <div className="panel-container">
      <div className="panel-content panel-content-customize">
        <ul className="nav nav-pills" role="tablist">
          {labels.map((item: any, idx: number) => (
            <NavLink
              key={idx}
              to={item.path}
              className={
                pathname === item.path ? "nav-link active" : "nav-link"
              }
            >
              {item.label}
            </NavLink>
          ))}
        </ul>
      </div>
      {children}
    </div>
  );
};

export default TabPanel;
